import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-kitchen-cream pt-10 md:pt-16 pb-12 md:pb-20 px-5 md:px-12 lg:px-24 overflow-hidden" data-id="element-68">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12" data-id="element-69">
        <div className="flex-1 text-center lg:text-left" data-id="element-70">
          <FadeIn data-id="element-71">
            <h1 className="font-lora text-3xl md:text-5xl lg:text-6xl font-bold text-kitchen-brown leading-tight mb-4 md:mb-6" data-id="element-72">
              Cómo Generar tus Primeros{' '}
              <span className="text-kitchen-terracotta" data-id="element-73">
                $100-$150 USD Diarios
              </span>{' '}
              Desde tu Propia Cocina{' '}
              <span className="text-kitchen-amber" data-id="element-74">
                (Sin Papeles y Sin Auto)
              </span>
            </h1>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-75">
            <p className="font-nunito text-base md:text-xl text-kitchen-brown/80 mb-6 md:mb-10 leading-relaxed" data-id="element-76">
              La estrategia exacta para mujeres latinas en USA que necesitan
              dinero en efectivo HOY mismo, usando lo que ya tienen en su
              alacena y su cuenta de WhatsApp.
            </p>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-77">
            <Button href="https://mujercashflow.com/cart/46609698128062:1" data-id="element-78">
              ¡SÍ, QUIERO EMPEZAR MI NEGOCIO HOY!
            </Button>
          </FadeIn>
        </div>
        <div className="flex-1 w-full max-w-sm md:max-w-md lg:max-w-none" data-id="element-79">
          <FadeIn delay={0.3} data-id="element-80">
            <motion.div animate={{
            y: [0, -15, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} data-id="element-81">
              <img src="https://cdn.magicpatterns.com/uploads/neZnx6MVC42eMRvSMmUxeM/El_metodo_lunchera_vecinal.png" alt="El Método Lunchera Vecinal" className="w-full h-auto rounded-2xl shadow-2xl border-4 border-white" data-id="element-82" />
            </motion.div>
          </FadeIn>
        </div>
      </div>
    </section>;
}